/**
 * Clock configuration for the application
 * Centralizes timezone settings used throughout the app
 */

/**
 * Default timezone for the application
 * Used for displaying times in the local timezone and for DateTime operations
 */
export const DEFAULT_TIMEZONE = 'Europe/Prague';
